/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { FilterType, InvalidResponse, ProductReviewFilterState, ReviewFilter } from '../../model';
import {
	addMultipleReviewFilters,
	addReviewFilter,
	addSearchFilter,
	addSelectedTag,
	addSortFilter,
	cleanReviewFilterRatings,
	cleanReviewFilters,
	cleanSelectedTag,
	removeReviewFilter,
	removeSearchFilter,
	removeSelectedTag,
	removeSortFilter
} from '../actions';

export const initialProductReviewsFilterState: ProductReviewFilterState = {
	selectedTag: new InvalidResponse(),
	filters: new InvalidResponse(),
	search: new InvalidResponse(),
	sort: new InvalidResponse()
};

export const productReviewsFilterReducers = createReducer(
	initialProductReviewsFilterState,
	on(addSelectedTag, (state, { selectedTag }) => ({
		...state,
		selectedTag
	})),
	on(removeSelectedTag, (state, { tagId }) => {
		const selectedTag = state.selectedTag;

		const updatedSelectedTag =
			selectedTag instanceof InvalidResponse || selectedTag.id === tagId
				? new InvalidResponse()
				: selectedTag;

		return {
			...state,
			selectedTag: updatedSelectedTag
		};
	}),
	on(cleanSelectedTag, (state) => ({ ...state, selectedTag: new InvalidResponse() })),
	on(addReviewFilter, (state, { filter }) => {
		const updatedFilters: ReviewFilter[] =
			state.filters instanceof InvalidResponse ? [filter] : [...state.filters, filter];

		return {
			...state,
			filters: updatedFilters
		};
	}),
	on(removeReviewFilter, (state, { filterId }) => {
		let updatedFilters = state.filters;

		if (!(updatedFilters instanceof InvalidResponse)) {
			const copyFilters: ReviewFilter[] = [...updatedFilters];
			const index = copyFilters.findIndex(({ id }) => id === filterId);

			if (index > -1) {
				copyFilters.splice(index, 1);
				updatedFilters = copyFilters;
			}
		}

		return {
			...state,
			filters: updatedFilters
		};
	}),
	on(cleanReviewFilterRatings, (state) => {
		let updatedFilters = state.filters;

		if (!(updatedFilters instanceof InvalidResponse)) {
			const copyFilters: ReviewFilter[] = [...updatedFilters];
			updatedFilters = copyFilters.filter(({ type }) => type !== FilterType.RATING);
		}

		return {
			...state,
			filters: updatedFilters
		};
	}),
	on(addMultipleReviewFilters, (state, { filters }) => {
		const updatedFilters: ReviewFilter[] =
			state.filters instanceof InvalidResponse ? filters : [...state.filters, ...filters];

		return {
			...state,
			filters: updatedFilters
		};
	}),
	on(cleanReviewFilters, (state) => ({
		...state,
		filters: new InvalidResponse()
	})),
	on(addSearchFilter, (state, { search }) => ({
		...state,
		search
	})),
	on(removeSearchFilter, (state) => ({
		...state,
		search: new InvalidResponse()
	})),
	on(addSortFilter, (state, { sort }) => ({
		...state,
		sort
	})),
	on(removeSortFilter, (state) => ({
		...state,
		sort: new InvalidResponse()
	}))
);

export const productReviewsFilterReducer = (state: ProductReviewFilterState, action: Action) =>
	productReviewsFilterReducers(state, action);
